var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchangeLinkAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1107 0.350208C21.4749 0.362032 21.7606 0.666902 21.7488 1.03115C21.4994 8.71379 15.0706 14.7336 7.38848 14.4842C7.02423 14.4724 6.73853 14.1676 6.75035 13.8033C6.76218 13.439 7.06705 13.1533 7.4313 13.1652C14.3854 13.3909 20.204 7.94191 20.4297 0.988334C20.4415 0.624082 20.7464 0.338383 21.1107 0.350208Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6681 0.145805C20.952 -0.0826738 21.3674 -0.0377218 21.5959 0.246208L23.8527 3.05071C24.0811 3.33464 24.0362 3.75003 23.7523 3.97851C23.4683 4.20699 23.0529 4.16204 22.8245 3.87811L20.5677 1.0736C20.3392 0.789674 20.3842 0.374285 20.6681 0.145805Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5955 0.244529C21.8249 0.527711 21.7813 0.943246 21.4981 1.17265L18.753 3.39646C18.4698 3.62586 18.0543 3.58227 17.8249 3.29908C17.5955 3.0159 17.6391 2.60037 17.9223 2.37096L20.6674 0.147159C20.9505 -0.0822471 21.3661 -0.0386528 21.5955 0.244529Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25817 13.6383C2.50756 5.95566 8.9364 -0.0641625 16.6185 0.185211C16.9827 0.197035 17.2684 0.501905 17.2566 0.866156C17.2448 1.23041 16.9399 1.51611 16.5757 1.50428C9.62152 1.27854 3.80296 6.72755 3.57724 13.6811C3.56541 14.0454 3.26054 14.3311 2.89629 14.3192C2.53204 14.3074 2.24634 14.0026 2.25817 13.6383Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.246204 10.6907C0.530132 10.4622 0.945522 10.5072 1.174 10.7911L3.43083 13.5956C3.65932 13.8796 3.61437 14.2949 3.33044 14.5234C3.04651 14.7519 2.63112 14.707 2.40264 14.423L0.145809 11.6185C-0.0826726 11.3346 -0.0377243 10.9192 0.246204 10.6907Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17361 11.3703C6.40301 11.6534 6.35942 12.069 6.07624 12.2984L3.33114 14.5222C3.04796 14.7516 2.63242 14.708 2.40302 14.4248C2.17361 14.1416 2.21721 13.7261 2.50039 13.4967L5.24549 11.2729C5.52867 11.0435 5.9442 11.0871 6.17361 11.3703Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeLinkAdd);
export default __webpack_public_path__ + "static/media/exchange_link_add.487478cb419850ce554a6db74aea4f9d.svg";
export { ForwardRef as ReactComponent };